import { Container, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Prompt } from 'react-router-dom';
import AssessmentQuestionWizard from "../../components/quiz-assessment/assessment-question-wizard";
import dataProvider from "../../providers/data-provider";
import TestFinishModal from "./test-finish-modal.component";
import TestTimer from "./test-timer.component";
import TestFinishConfirmationDialog from "./test-finish-confirmation-dialog";

const LEFT_MESSAGE = 'Ao sair da página, seu simulado será finalizado imediatamente e você não poderá alterar nada mais. Deseja prosseguir ?';

const TestResolutionPage = ({ data, availability, isDemoTest }) => {

    const [timeFinished, setTimeFinished] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [confirmFinishOpen, setConfirmFinishOpen] = useState(false);
    const [pendingAnswers, setPendingAnswers] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [evaluateData, setEvaluateData] = useState(null);
    const [allowNavigation, setAllowNavigation] = useState(false);

    const handleSubmitTest = async (answers) => {
        setAllowNavigation(true);
        setSubmitting(true);

        const parsed = Object.keys(answers).map((key) => ({
            questionId: key,
            optionId: answers[key],
        }));

        dataProvider.patch('quiz-assessment-test', 'save-result', {
            testId: data.id,
            response: parsed,
        })
            .then((res) => setEvaluateData(res.data))
            .finally(() => setSubmitting(false));
    };

    const handleTimeFinish = (val) => {
        if (!modalOpen && !timeFinished) {
            setTimeFinished(val);
        }
    };

    // Called by wizard when forceFinish triggers (timer expired)
    const handleForceFinish = ({ answers }) => {
        if (!modalOpen) {
            setModalOpen(true);
            handleSubmitTest(answers);
        }
    };

    // Called by wizard when user clicks the Finish button
    const handleFinishRequest = ({ answers }) => {
        setPendingAnswers(answers);
        setConfirmFinishOpen(true);
    };

    const handleConfirmFinish = () => {
        setConfirmFinishOpen(false);
        setModalOpen(true);
        handleSubmitTest(pendingAnswers);
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            return true;
        };
        if (!allowNavigation)
            window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [allowNavigation]);

    return (
        <Container maxWidth="xl" style={{ marginTop: "2rem" }}>
            <Typography variant="h4" gutterBottom>
                {availability.name}
            </Typography>
            <Prompt when={!allowNavigation} message={LEFT_MESSAGE} />
            <TestTimer
                startedAt={data.startedAt}
                durationInMinutes={availability.durationInMinutes}
                timeLimit={data.durationInMinutes ? data.durationInMinutes * 60 : null}
                handleTimeFinish={handleTimeFinish}
            />
            <AssessmentQuestionWizard
                questions={data.questions}
                forceFinish={timeFinished}
                onFinish={handleFinishRequest}
                onForceFinish={handleForceFinish}
                disabled={timeFinished || modalOpen}
            />
            <TestFinishConfirmationDialog
                open={confirmFinishOpen}
                onClose={() => setConfirmFinishOpen(false)}
                onConfirm={handleConfirmFinish}
            />
            <TestFinishModal
                finishedByAnswers={modalOpen}
                finishedByTimeout={timeFinished}
                submitting={submitting}
                evaluateData={evaluateData}
                availability={null}
            />
        </Container>
    );
};

export default TestResolutionPage;
